import * as Yup from "yup";

const Form4 = Yup.object({
  fullName: Yup.string().required("Full Name is required"),
  contactPhone: Yup.string()
    .nullable(),
});

export default Form4;
